export enum BgStatus {
	NOVA = 'nova',
	CL_CHECKED = 'cl_checked', // Предзаявка одобрена, заполнение заявки
	CL_REJECTED = 'cl_rejected', // Отказ
	CONSENT = 'consent', // Согласия получены
	CREATED = 'created', // Создана, Заполнение
	POST_REQUEST_ERROR = 'post_request_error', // Ошибка при создании реквеста
	FILLING = 'filling', // Ожидает подписания
	ONLINE_CHECKING = 'online_checking', // Принятие решения
	APPROVAL_TEXT = 'approval_text', // Согласование текста гарантии
	SENDING = 'sending', // На проверке банка
	REWORK = 'rework', // На доработке
	PAY_WAITING = 'pay_wating', // Ожидает оплаты
	CHECKING = 'checking', // Подготовка гарантии
	SENT_BANK = 'sent_bank', // Ожидает выпуска
	RELEASED = 'released', // Выпущена
	CLOSED = 'closed', // Закрыта
	REJECTED = 'rejected', // Отказ Банка
	AST_CHECKING = 'ast_checking', // Дополнительная проверка
	DELETED = 'deleted', // Удалена,
	SENT_BANK_COMMERCIAL = 'sent_bank_commercial', // "Отправлена в банк" для комм. заявок
	CALL_BY_CLIENT = 'call_by_client', // Клиент просил перезвонить
	CALL_NOT_RESPONDING = 'call_not_responding', // Назначен повторный звонок
	CALL_MISSED = 'call_missed', // Финальный недозвон
	CLIENT_REFUSAL = 'client_refusal', // Отказ клиента
	AGREE_TO_PRODUCT = 'agree_to_product', // Согласен на продукт
	CLOSED_REFUSAL = 'closed_refusal', // Закрыта/Отказ
	CLOSED_CONCLUSION = 'closed_conclusion', // Закрыта/Заключена
	WAITING_FOR_ACCEPTANCE = 'waiting_for_acceptance', // Ожидание согласия с одобренными условиями
	ADDITIONAL_CHECK = 'additional_check', // Доп.проверка/подготовка к сделке
	NOT_SIGNED_BY_CLIENT = 'not_signed_by_client', // Не подписана клиентом
	UPLOADING_DOCUMENTS_BY_CLIENT = 'uploading_documents_by_client', // Загрузка документов клиентом
	DEAL_ANALYSIS = 'deal_analysis', // Анализ сделки
}

export enum BgSubStatus {
	WITH_DOCUMENTS_SENT = 'with_documents_sent',
	SENDING_DOCUMENTS = 'sending_documents',
	SENDING_DOCUMENTS_FAILURE = 'sending_documents_failure',
}

export const bgFinishedStatus = [BgStatus.CLOSED, BgStatus.REJECTED]
export const bgStatusUpdateClosed = [BgStatus.NOVA, BgStatus.CL_CHECKED, ...bgFinishedStatus]
export const bgAccessUpdate = [BgStatus.FILLING, BgStatus.REWORK]
export const bgAccessCheckLimitUpdate = [BgStatus.CL_CHECKED]
export const bgReworkButtonStatus = [
	BgStatus.SENDING,
	BgStatus.AST_CHECKING,
	BgStatus.CHECKING,
	BgStatus.PAY_WAITING,
]

export const bgAccessAstSignedStatuses = [
	BgStatus.CHECKING,
	BgStatus.CL_CHECKED,
	BgStatus.RELEASED,
	BgStatus.REJECTED,
	BgStatus.DELETED,
	BgStatus.CLOSED,
	BgStatus.PAY_WAITING,
]

export const bgHideCommentStatus = [
	BgStatus.CHECKING,
	BgStatus.CL_CHECKED,
	BgStatus.RELEASED,
	BgStatus.SENT_BANK,
	BgStatus.SENDING,
]
